import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';
import { graphql } from 'react-apollo';
import { Link } from 'react-router';
import gql from 'graphql-tag';
import moment from 'moment';

import Container from '../Container';
import styles from '../ContactSuccess/contact-success.css';

const { div, h1, p, span } = hh(h);

function PaymentSuccess({ data: { loading, submission }, ...props}) {
    if(loading) {
        return div({}, ['Loading..']);
    } else {
        return (
            h(Container, {theme: 'five'}, [
                div({className: styles.container}, [
                    h1({className: styles.title}, 'This is going to be epic!'),
                    p({className: styles.message}, `${submission.user.firstName}, you're all set to attend the ${submission.course.name} course at ${submission.course.university.name}!`),
                    p({className: styles.message}, `${moment(submission.course.startDate).format('MMM Do')} - ${moment(submission.course.endDate).format('Do YYYY')}`),
                    h(Link, {to: '/', className: styles.link}, [
                        span({className: styles.backArrow, dangerouslySetInnerHTML: {__html: '&larr;'}}),
                        span({className: styles.backText}, 'Back to the site')])])])
                    );
    }
};

export default graphql(gql`
    query($submissionId: String!){
        submission(id: $submissionId) {
            id
            state

            course {
                id
                name
                startDate
                endDate

                university {
                    name
                }
            }
            user {
                id
                firstName
                lastName
                email
            }
        }
    }
`, {
    options({ params: { id }}) {
        return { variables: { submissionId: id }};
    }
})(PaymentSuccess);



/** WEBPACK FOOTER **
 ** ./src/PaymentSuccess/index.js
 **/